<span class="player-name-display">
  <PlayerTitle v-if="showTitle" class="me-1" :player="player" :club-id="clubId" :title="title" />
  <span>{{ displayName }}</span>
  <span v-if="withdrawn"> (w/d)</span>
</span>
